import { ClipboardCheck, Phone } from "lucide-react";
import { site, offer, whatsappPrefill } from "@/config/site";
import { Section } from "./Section";
import { Reveal } from "./Reveal";

const REPORT_ROWS = [
    "Paint condition",
    "Swirl marks & scratches",
    "Gloss & finish",
    "Interior condition",
    "Existing protection",
    "Detailing & restoration needs",
];

export const Inspection = () => (
    <Section id="inspection" index="05" label="Free Inspection" title="Know your car before you spend.">
        <div className="mt-14 grid gap-10 lg:grid-cols-2 lg:gap-16">
            <Reveal delay={0.05}>
                <p className="max-w-[55ch] text-base leading-relaxed text-rz-smoke sm:text-lg">
                    A Revautoz inspection identifies the visible areas of your vehicle that need
                    attention — before any service is recommended. You receive a clear, honest
                    report on your car's condition, with no obligation to book anything.
                </p>
                <p className="mt-5 max-w-[55ch] text-base leading-relaxed text-rz-smoke">
                    It answers the only question that matters first: what does your car actually
                    need?
                </p>
                <div className="mt-9 flex flex-wrap gap-4">
                    <a
                        data-testid="inspection-cta"
                        href={whatsappPrefill(offer.message)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-sweep inline-flex items-center gap-2 bg-rz-red px-8 py-4 font-display text-[12px] font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:bg-rz-reddeep"
                    >
                        <ClipboardCheck size={15} /> Get your free inspection report
                    </a>
                    <a
                        data-testid="inspection-call"
                        href={`tel:${site.phone}`}
                        className="inline-flex items-center gap-2 border border-rz-white/40 px-8 py-4 font-display text-[12px] font-semibold uppercase tracking-[0.18em] text-rz-white transition-colors duration-300 hover:border-rz-white"
                    >
                        <Phone size={14} /> Call the studio
                    </a>
                </div>
            </Reveal>
            <Reveal delay={0.12}>
                <div
                    data-testid="inspection-report-card"
                    className="rz-corners border border-rz-steel/60 bg-rz-graphite/50"
                >
                    <div className="flex items-center justify-between border-b border-rz-steel/60 px-6 py-4">
                        <p className="font-display text-[11px] font-semibold uppercase tracking-[0.22em] text-rz-white">
                            Revautoz Vehicle Inspection
                        </p>
                        <span className="border border-rz-red/60 px-2.5 py-1 font-display text-[9px] uppercase tracking-[0.22em] text-rz-red">
                            Sample
                        </span>
                    </div>
                    <ul>
                        {REPORT_ROWS.map((r, i) => (
                            <li
                                key={r}
                                className="flex items-center justify-between border-b border-rz-steel/40 px-6 py-3.5 last:border-b-0"
                            >
                                <span className="flex items-center gap-3 text-sm text-rz-white/90">
                                    <span className="font-display text-[10px] tracking-[0.2em] text-rz-red">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    {r}
                                </span>
                                <span className="font-display text-[9px] uppercase tracking-[0.2em] text-rz-smoke">
                                    Assessed in studio
                                </span>
                            </li>
                        ))}
                    </ul>
                    <p className="border-t border-rz-steel/60 px-6 py-4 text-[12px] leading-relaxed text-rz-smoke">
                        Completed after a physical inspection at the studio. No fabricated scores —
                        just an honest read of your car.
                    </p>
                </div>
            </Reveal>
        </div>
    </Section>
);
